// Retailer-Themed Search Workspace — canonical registry (mirrors backend's
// data/retailers.py 1:1 for id/domain/fulfillment; colors/labels are UI-only).
export const RETAILERS = [
  { id: "amazon", name: "Amazon", primary: "#232F3E", accent: "#FF9900", fulfillment: "ONLINE_SHIPPING" },
  { id: "bestbuy", name: "Best Buy", primary: "#003B64", accent: "#FFE000", fulfillment: "ONLINE_SHIPPING" },
  { id: "target", name: "Target", primary: "#CC0000", accent: "#FFFFFF", fulfillment: "ONLINE_SHIPPING" },
  { id: "walmart", name: "Walmart", primary: "#0071CE", accent: "#FFC220", fulfillment: "ONLINE_SHIPPING" },
  { id: "ebay", name: "eBay", primary: "#E53238", accent: "#0064D2", fulfillment: "ONLINE_SHIPPING" },
  { id: "facebook_marketplace", name: "Facebook Marketplace", primary: "#1877F2", accent: "#FFFFFF", fulfillment: "IN_STORE_PICKUP" },
  { id: "stockx", name: "StockX", primary: "#046A38", accent: "#000000", fulfillment: "ONLINE_SHIPPING" },
  { id: "goat", name: "GOAT", primary: "#000000", accent: "#FFFFFF", fulfillment: "ONLINE_SHIPPING" },
];

export function getRetailer(id) {
  return RETAILERS.find((r) => r.id === id) || RETAILERS[0];
}
